const messages = {
    en: {
        translations: {
            citacao: {
                fist: '"The',
                spanOne: 'simplicity',
                second: 'is the highest degree of',
                spanTwo: 'sophistication"'
            },
            home: {
                hi: 'Say hi'
            },
            sobre: {
                hello: 'Hello',
                textOne: 'I am Joás Castelo and I am about to complete my degree in Digital Design at the Federal University of Ceará (UFC), with a focus on Front-end. I have skills in HTML, CSS, JavaScript, React and Vue.js, as well as experience in UX/UI. I am used to working in a team and applying agile methodologies.',
                textTwo: 'During my academic and professional journey I participated in the Informatics Practices Center (NPI) as UI/UX in creating the interface for an internship management system, using Figma as the main tool, I also participated in an extension scholarship as a fullstack, where I used React JS, Firebase, and the Google Maps API.',
                alt: 'young woman with glasses with part of her yellow hair and dark shirt'
            },
            skills: {
                education: 'Education',
                prototype: 'Prototype',
                uxText: 'Experience in UI/UX designer. Creating attractive and intuitive interfaces to stand out from the rest.',
                prototypeText: 'Knowledge of high-fidelity prototypes, getting the idea off the ground.',
                frontText: 'Knowledge of front-end development, creating the visual and interactive part of websites.',
                technologies: 'Technologies',
                HTMLText: 'Use of Html5 to define information and organization.',
                CSSText: 'In-depth knowledge of CSS for better styling.',
                JavascriptText: 'Use of the Java Script language to improve interaction.',
                TypecriptText: 'Use of the TypeScript language, currently widely used in front-end development.',
                tailwind: 'Knowledge of Tailwind that offers fast development, easy maintenance and high customization through its classes.',
                reactText: 'In-depth knowledge of React for better performance during development',
                vueText: 'Basic knowledge in Vue',
            },
            diferenciais: {
                differential: 'Differential',
                team: 'Team',
                dev: 'Development',
                internship: 'Internship',
                teamText: 'Experience in teamwork',
                devText: 'Developed web projects',
                internshipText: 'Experience in the job market with internship in the IT practice center',
                scrumText: 'Usual in using agile methodologies',
            },
            projetos: {
                fortaleza: 'An extension grant where I was responsible for migrating a mobile app to desktop. I had the fullstack pael and worked with react, firebase and the google maps api, in addition to creating the interface. This project aims to mark and bring information about songs that mention places in Fortaleza.',
                ecomerce: 'A complete e-commerce project to improve my knowledge in Vue3.',
                deco: 'Done at the deco.cx bootcamp, learning how to create interfaces that have an admin to control information and styles. The system was built using preact and deno, along with TypeScript.',
                planner:'System made on the NLWJourney ReactJS track offered by rocketseat. The objective of the project is to create a travel planner where you can choose a location, invite friends via email, schedule events by date and time, and add useful links, all using TypeScript, Tailwind, and NodeJS.',
                estagio: 'Developed during my internship at (NPI), which consists of a system for exchanging documents related to internships between students and teachers, as part of the design team, we were responsible for thinking about the system is interface with a high-fidelity and navigable prototype.',
                moteis: 'This project to redesign the landing page of the go motel guide app, among the deliverables are: design system, wireframe, high fidelity prototype and navigable peototype.',
                holding: 'Developed during my internship at Compass UOL, this project involved creating a mobile application focused on supporting mental health. To achieve this, we conducted an in-depth exploration of the topic through interviews with mental health professionals and users, ensuring a solution aligned with real user needs.'

            }
        }
    }
}

export { messages }